import { render, staticRenderFns } from "./MatchResult.vue?vue&type=template&id=cca8bd52&scoped=true&"
import script from "./MatchResult.vue?vue&type=script&lang=js&"
export * from "./MatchResult.vue?vue&type=script&lang=js&"
import style0 from "./MatchResult.vue?vue&type=style&index=0&id=cca8bd52&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cca8bd52",
  null
  
)

export default component.exports